export const APP_STORE_URL =
  "https://apps.apple.com/us/app/learn-danish-nemlingo-pd3/id6751247509";

export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.nemlingo.app&pcampaignid=web_share";

// Official store badges, served from /public
export const APP_STORE_BADGE = "/6571906d42dadee6d16f0a74_apple_store.png";
export const GOOGLE_PLAY_BADGE = "/65719077d1409ad0b2795218_google_play.png";
